// src/store/slices/settingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getGeneralSettings } from '../../api';

export const fetchSettings = createAsyncThunk(
    'settings/fetchSettings',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getGeneralSettings();
            // Handle axios response object
            const data = response.data;
            if (data.success) {
                console.log('Settings API Response:', data.data);
                return data.data;
            } else {
                console.error('Settings API Error:', data.message);
                return rejectWithValue(data.message || 'Failed to fetch settings');
            }
        } catch (err) {
            console.error('Settings Fetch Exception:', err);
            return rejectWithValue(err.message || 'Failed to fetch settings');
        }
    }
);

const settingSlice = createSlice({
    name: 'settings',
    initialState: {
        general: {},
        maintenance: {},
        logo: {},
        store: {},
        others: {},
        storefront: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettings.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSettings.fulfilled, (state, action) => {
                state.loading = false;
                state.general = action.payload.general || {};
                state.maintenance = action.payload.maintenance || {};
                state.logo = action.payload.logo || {};
                state.store = action.payload.store || {};
                state.others = action.payload.others || {};
                // all storefront_* settings live inside the "others" sub-object
                state.storefront = Object.fromEntries(
                    Object.entries(action.payload.others || {}).filter(([k]) => k.startsWith('storefront_'))
                );
                state.error = null;
            })
            .addCase(fetchSettings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default settingSlice.reducer;
